import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import InfoIcon from '@material-ui/icons/Info';
import PortletToolbar from 'components/PortletToolbar';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {StickyTable, Row, Cell} from 'react-sticky-table';

import Period from '../../../../helpers/PeriodGeneralStatus';
import ObjectiveCell from './ObjectiveCell';
import Filter from '../../../..//helpers/Filter'
import ListObjectiveModal from '../ListObjectiveModal';
import {getObjectives} from '../../../../services/getObjectives'

import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import moment from 'moment-timezone'
import 'moment/locale/es'  
moment.locale('es')
const date=((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))

const INTERVAL_TIME = 300000

class QuickViewIsp extends Component {

    constructor(props) {
        //console.log("QuickViewIsp")
        super(props);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.infoAutoComplete = this.handleState.bind(this);
        var filter="Activos"
        var filterList=[{"nombre":"Activos"},{"nombre":"Downtime"}, {"nombre":"Downtime-Parcial"}, {"nombre":"Uptime"},{"nombre":"Todos"}]
        if(sessionStorage.getItem("filterOperative")!==null){
            filter=sessionStorage.getItem("filterOperative")
            var newFilterList = [{"nombre":filter}]
            filterList.map(ele=>{
                if(ele.nombre!==filter){
                    newFilterList.push(ele)
                }
            })
            filterList = newFilterList
        }
        this.state = {
            isOpen: false,
            path: null,
            listObjectives: {},
            nameStatus: 'Objetivos ',
            selectedOption: null,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            isStatePeriod: false,
            settingsEl: null,
            isInfo: null,
            date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"),
            objmodal: 0,
            objNameModal: '',
            openObjectiveModal: false,
            typeGraph: 0,
            period: 'h',
            namePeriod: null,
            namePeriodPorlet: ['Última Hora', 'Últimas 3 horas', 'Últimas 6 horas', 'Últimas 12 horas', 'Último día', 'Últimos 2 días'],
            typePeriod: 0,
            changeFilter: false,
            filter: filter,
            filterList: filterList,
            intervalId: null,
        }

    }
    
    setHoverData = (e) => {

        const { params } = this.state
        let name = e.point.name
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + name,
            listObjectives: params[name]
        });
    }
    setHoverDataBar = (e) => {

        const { params } = this.state
        const { category, series } = e.point
        let nameCat = category
        let nameStatus = series.name
        var filterParams = params[nameStatus].filter(param => param['grupo_servicio_unificado'] == nameCat)
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + nameCat,
            listObjectives: filterParams
        });
    }
    onOpenModal = () => {
        this.setState({ isOpen: true });
    };

    onCloseModal = () => {
        this.setState({ isOpen: false });
    };

    tick=()=>{
        //console.log('recarga cada 5 minutos')
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        sessionStorage.setItem("listsLoads",false)
        // window.location.reload()
        var filter="Activos"
        var filterList=[{"nombre":"Activos"},{"nombre":"Downtime"}, {"nombre":"Downtime-Parcial"}, {"nombre":"Uptime"},{"nombre":"Todos"}]
        if(sessionStorage.getItem("filterOperative")!==null){
            filter=sessionStorage.getItem("filterOperative")
            var newFilterList = [{"nombre":filter}]
            filterList.map(ele=>{
                if(ele.nombre!==filter){
                    newFilterList.push(ele)
                }
            })
            filterList = newFilterList
        }
        this.setState({
            isLoading: true,
            filterList: filterList
        })
        this.processData()
    }

    componentDidMount() {
        this.processData()
        const newInterval = setInterval(
            () => this.tick(),
            INTERVAL_TIME
        )
        this.setState({intervalId: newInterval})
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }
    
    processData = async () => {
        this.setState({isLoading: true})
        const { params } = this.props;
        var data = params
        const token = sessionStorage.getItem('key')
        const user_id = sessionStorage.getItem('user')
        /*OBTIENE OBJETIVOS POR ESTADO*/
        getObjectives(user_id, token).then(dataFetch=>{
            data = dataFetch
            sessionStorage.setItem("listsLoads",true)
                let objectivesList = []
                let nodesList = []
                Object.keys(data).map((key) => {
                    if (key !== 'Services' && key !=='ServicesUnified') {
                        Object(data[key]).map((objective, orden)=>{
                            if (objective['estado'] == 'Uptime'){
                                objective['color_custom'] = 'rgb(65, 185, 0)'
                            } else if (objective['estado'] == 'Downtime'){
                                objective['color_custom'] = 'rgb(194, 39, 45)'
                            } else if (objective['estado'] == 'Parcial'){
                                objective['color_custom'] = 'rgb(255, 198, 0)'
                            } else if (objective['estado'] == 'No monitoreo'){
                                objective['color_custom'] = 'rgb(169, 169, 169)'
                            }
                            objectivesList.push(objective)
                            Object(objective.Nodos).map((node, orden)=>{
                                nodesList.push(node)
                            })
                        })
                    }
                })
                var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4};
                objectivesList.sort(function (a, b) {
                    var priorityA = order[a.estado] || Infinity;
                    var priorityB = order[b.estado] || Infinity;

                    var nombreA = (a.nombre).toLowerCase()
                    var nombreB = (b.nombre).toLowerCase()

                    if (priorityA < priorityB) return -1;
                    if (priorityA > priorityB) return 1;

                    if (nombreA < nombreB) return -1;
                    if (nombreA > nombreB) return 1;
                    return 0;
                })
                var groupedNodes = groupBy(nodesList, 'id_nodo');
                let nodesIdList = []
                Object.keys(groupedNodes).map(key => {
                    if (key != 0){
                        nodesIdList.push(key)
                    }
                })
                this.setState({
                    objectivesList: objectivesList,
                    nodesList: nodesList,
                    nodesIdList: nodesIdList,
                    groupedNodes: groupedNodes,
                    loadObjectiveData: true,
                    listObjetivesData: data,
                    isLoading: false,
                    params: data,
                    date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a")
                });
            });
    }

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleChange = (selectedOption) => {
        const { passProps } = this.props
        this.setState({ selectedOption });
        //passProps.onClick(passProps, selectedOption.value)
    };
    
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleRefresh = () => {
        this.tick()
    };

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 1,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '6hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '6h',
                typePeriod: 2,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '12hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '12h',
                typePeriod: 3,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 4,
                //namePeriod: 'Rango: último día',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '2dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "2d",
                typePeriod: 5,
                //namePeriod: 'Rango: últimos 3 días',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } 
    }
    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    scroll = (scrollOffset) => {
        const scrollContainer = ReactDOM.findDOMNode(this.scrollRef);
        scrollContainer.scrollLeft += scrollOffset;
    };

    handleState=(e,x)=>{
        var stateObj =  x.nombre
        if(stateObj==="Downtime"){
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : x.nombre
            });
        }else if(stateObj==="Downtime-Parcial"){
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : "Parcial"
            });
        }else if(stateObj==="Uptime"){
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : x.nombre
            })
        }else if(stateObj==="Todos"){
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : x.nombre
            })
        }else{
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : x.nombre
            });
        }

        sessionStorage.setItem("filterOperative",  stateObj)
    }

    render() {
        const { isLoading, date, settingsEl, isInfo, objectivesList, loadObjectiveData, listObjetivesData,
            objIdModal, objNameModal, openObjectiveModal, periodEl, typeGraph, period, isOneHour, namePeriodPorlet, 
            typePeriod, nodesList, groupedNodes, nodesIdList, filterList, filter} = this.state;
        const { classes, className, handleClose, isForModal, ...rest } = this.props;

        const rootClassName = classNames(classes.root, className);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        let isForModalEl = false
        if (isForModal == true){
            isForModalEl = true
        }

        if (isLoading) {
            return (
                <div style={{ marginTop: "20px", display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h5">
                    <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    Cargando Información...
                    </Typography>
                </div>
            );
        }
    
        return (
            <Portlet className={rootClassName}>
                <PortletHeader className={classes.header}>
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                            <Avatar variant="rounded" className={classes.rounded}>
                            <UpdateIcon /> 
                            </Avatar>
                            <Typography  className={classes.updateTime}>
                                    &nbsp; Última actualización: {date} 
                            </Typography>
                        </div>
                   
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                            <IconButton
                                onClick={this.handleShowSettings}
                                styles={{float:'right'}}
                            >
                                <SettingsOutlinedIcon />
                            </IconButton>
                            {isForModalEl ?
                                <IconButton 
                                    onClick={handleClose}
                                >
                                    <ClearIcon/>
                                </IconButton>
                            : null}
                        </div>
                    <Popover
                        anchorEl={periodEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleClosePeriod}
                        open={showPeriodEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={isOneHour}/>
                    </Popover>
                    <Popover
                        anchorEl={settingsEl}
                        onClose={this.handleCloseSettings}
                        open={showSettingsEl}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                            }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                    }}
                    >
                    <IconButton style={{display: 'flex', justifyContent: 'space-between'}} 
                        onClick={this.handleRefresh}
                    > 
                        <RefreshIcon color="#66788A" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>    
                    </IconButton>
                                    
                </Popover>
                </PortletHeader>
                <PortletContent className={classes.content}>
                    {loadObjectiveData ?
                        <div style={{width: '100%', /*height: '70vh'*/}}>
                            <div style={{width: '50%'}}>
                                <Filter list={filterList} label={"Seleccione Estado"} 
                                    InfoAutoComplete={this.handleState} placeholder={"Estados"}/>
                            </div>
                            <div style={{ float:'right'}}>
                                <IconButton onClick={() => this.scroll(-516)}><NavigateBeforeIcon/></IconButton>
                                <IconButton onClick={() => this.scroll(516)}><NavigateNextIcon/></IconButton>
                                <Typography variant="h6" style={{color:'black'}}>{Object.keys(groupedNodes).length+" monitor(es)"}</Typography>
                            </div>
                            <StickyTable style={{width: '100%'}} ref={(ref) => (this.scrollRef = ref)} stickyHeaderCount={1} leftStickyColumnCount={1}>
                                <div>
                                    <Row >
                                        <Cell style={{backgroundColor:'#373537', maxWidth:'280px', minWidth:'280px'}}> <Typography variant="h4" style={{color:'white'}}>Objetivos</Typography></Cell>
                                        {Object.keys(groupedNodes).map(key => (
                                            key != 0 ?
                                                <Tooltip 
                                                    title={<div><Typography variant="h5" style={{color:'white'}}>{groupedNodes[key][0].titulo}</Typography>
                                                            <Typography variant="h6" style={{color:'white'}}>{groupedNodes[key][0].subtitulo}</Typography></div>} placement="bottom" arrow>
                                                    <Cell style={{backgroundColor:'#373537', maxWidth:'130px', minWidth:'130px', borderRight: "2px solid #e4dede"}}>
                                                        <Typography variant="h4" style={{color:'white'}}>{groupedNodes[key][0].titulo.substr(0,10)}</Typography>
                                                        <Typography align='right' style={{color:'white'}}>{groupedNodes[key][0].subtitulo.substr(0,15)}</Typography>
                                                    </Cell>
                                                </Tooltip>
                                            : null
                                        ))}
                                    </Row>
                                    
                                    {Object.keys(objectivesList).map(key => (
                                        filter === "Todos"||objectivesList[key].estado == filter ?
                                            <ObjectiveCell objectivesList={objectivesList[key]} nodesIdList={nodesIdList} handleOpenObjectiveModal={this.handleOpenObjectiveModal}/>
                                        : filter==="Activos"&&objectivesList[key].estado !== "No monitoreo"?
                                            <ObjectiveCell objectivesList={objectivesList[key]} nodesIdList={nodesIdList} handleOpenObjectiveModal={this.handleOpenObjectiveModal}/>
                                        : null
                                    ))}
                                </div>
                            </StickyTable>
                        </div>
                    :  <PerfectScrollbar>
                            <Typography
                                variant="h5">
                                <CircularProgress
                                    variant="indeterminate"
                                    size={24}
                                    thickness={4}
                                    />
                                <br/>
                                Cargando Información...
                            </Typography>
                        </PerfectScrollbar>}
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={openObjectiveModal}
                            onClose={this.handleCloseObjectiveModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            closeAfterTransition
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                        <Fade in={openObjectiveModal}>
                            <PerfectScrollbar style={{position:"static"}}>
                            <div className={classes.div}>                             
                                <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjetivesData} handleClose={this.handleCloseObjectiveModal}/>                        
                            </div>
                            </PerfectScrollbar>
                        </Fade>
                        </Modal>
                </PortletContent>
                
            </Portlet>
        )
    }
}

function FormattedChart(props) {
    return ( 
        <div>
            <div style={props.style}>
{/*                 <div style={{float:"left"}}>
                    <div style={{float:"left"}}>
                        <QueryBuilderIcon/>
                    </div>
                    <Typography  style={{width:"380px", height:"1px", float:"right", marginTop:"5px", paddingLeft:"3px"}} color="textSecondary" gutterBottom>
                        Última Actualización {props.date}
                    </Typography>
                </div> */}
                <Grid
                    container
                    spacing={2}
                    
                >           
                    <Grid item
                        sm={12}
                        xl={12}
                        xs={12}
                        >
                        {Object.keys(props.listObjectives).map(key => (
                            <Button id={props.listObjectives[key].objetivo_id} value={props.listObjectives[key].nombre} onClick={props.handleOpenObjectiveModal}>
                                {/*<GeneralStatusAvailabilityConsolidated objetivo_name={props.listObjectives[key].nombre} objetivo_id={props.listObjectives[key].objetivo_id} period={props.period}/>*/}
                            </Button>
                        ))}
                    </Grid> 
                </Grid>    
            </div>   
        </div>        
           
    )
}

function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}
QuickViewIsp.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(QuickViewIsp);